import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useWindowWidth } from "@react-hook/window-size";
import { useRecoilValue } from "recoil";
import { Trans, useTranslation } from "react-i18next";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";

import {
  BabyPeekIntroWrapper,
  BabyPeekIntroBodyWrapper,
  BabyPeekIntroTitle,
  BabyPeekIntroDescription,
  BabyPeekIntroBottomMobileGrid,
  BabyPeekIntroInfoBarWrapper,
  BabyPeekIntroInfoBarBigMobile,
  BabyPeekIntroInfoBarDescriptionMobile,
  BabyPeekIntroCTAWrapper,
  BabyPeekCTATitle,
  BabyPeekFAQTitle,
  BabyPeekIntroFAQAccordionWrapper,
  BabyPeekMobileFAQ,
  BabyPeekDisclaimer,
  BabyPeekDisclaimerGrid,
  BabyPeekDisclaimerText,
  BabyPeekDisclaimerTitle,
  BabyPeekIntroPaymentMobileButtonWrapper,
  BabyPeekIntroMobileDescriptionWrapper,
  BabyPeekMobileHeaderImageWrapper,
  BabyPeekIntroMarqueeWrapper,
  BabyPeekRatingsWrapper,
} from "./BabyPeekIntro.styles";

import { BabyPeekButton } from "./BabyPeekButton";
import { TraitMarquee } from "./TraitMarquee";

import {
  BabyPeekAccordions,
  babyPeekGameAccordion,
  getBabyPeekFAQAccordion,
} from "./BabyPeekAccordion";
import { DetailedResultsBabyPeekText } from "../DetailedResults/DetailedResults.styles";
import { EyeCTA } from "./BabyPeekIcons/EyeCTA";
import { TasteCTA } from "./BabyPeekIcons/TasteCTA";
import { TeethCTA } from "./BabyPeekIcons/TeethCTA";
import { WaveCTA } from "./BabyPeekIcons/WaveCTA";
import {
  BabyPeekPaymentPromotionGradient,
  BabyPeekPaymentPromotionGradientContent,
  BabyPeekPaymentGradientContentSpecialGrid,
  BabyPeekPaymentGradientTitle,
  BabyPeekPaymentSummaryItemGridRow,
  BabyPeekPaymentSummaryTitleTrait,
  BabyPeekPaymentSummaryDescription,
  BabyPeekPaymentGradientTitleMobile,
  BabyPeekPaymentGradientTitleStrikeThrough,
  BabyPeekPaymentPromotionalPriceGrid,
  BabyPeekMobileButtonSticky,
  BabyPeekPreTestMessage,
} from "./BabyPeekStripe.styles";
import {
  BabyPeekButtonNames,
  BabyPeekTraitResponse,
  getUnlockButtonText,
} from "./Services/BabyPeekService";
import { getCentsToDollars } from "../UpfrontPayment/Services/UpfrontPaymentService";
import useScrollPosition from "../../utils/hooks/useScrollHeight";
import { BabyPeekIcon } from "./BabyPeekIcons/BabyPeekIcon";
import { BABYPEEK_URL } from "../../utils/urlConstants";
import BabyPeekVideoEmbed from "../shared/Video/BabyPeekVideoEmbed";
import { TraitSummaryList } from "./BabyPeekIcons/TraitSummaryList";
import { FutureFoodie } from "./BabyPeekIcons/FutureFoodie";
import { TechnologyGene } from "./BabyPeekIcons/TechnologyGene";
import { BabyPeekVerticalQuotes } from "./BabyPeekQuotes";
import { BabyPeekRatings } from "./BabyPeekIcons/BabyPeekRatings";
import { BabyPeekRatingsStar } from "./BabyPeekIcons/BabyPeekRatingsStar";
import { BabyPeekGamesExplosions } from "./BabyPeekIcons/BabyPeekGamesExplosions";
import { BabyPeekGamesExclusive } from "./BabyPeekIcons/BabyPeekGamesExclusive";
import { getUserAuth } from "../../recoil/selectors";
import BabyPeekMultipleReqHeader from "./BabyPeekMultipleReqHeader";

export const BabyPeekIntroMobile: React.FC<{
  babyPeekReport: BabyPeekTraitResponse;
  babyPeekPKVal?: string;
  setLastButtonClick?: React.Dispatch<
    React.SetStateAction<BabyPeekButtonNames | undefined>
  >;
}> = ({ babyPeekReport, babyPeekPKVal, setLastButtonClick }) => {
  const { t } = useTranslation();
  const { deviceType } = useDeviceHook();
  const windowWidth = useWindowWidth();
  const history = useHistory();
  const scrollPosition = useScrollPosition();
  const auth = useRecoilValue(getUserAuth);
  const [registryLinkCopied, setRegistryLinkCopied] = useState(false);
  let { babypeekPK } = useParams<{
    babypeekPK: string;
  }>();
  babypeekPK = babypeekPK ?? babyPeekPKVal;

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (registryLinkCopied) {
      timeout = setTimeout(() => {
        setRegistryLinkCopied(false);
      }, 4000);
    }
    return () => clearTimeout(timeout);
  }, [registryLinkCopied]);

  return (
    <>
      <div
        style={{
          display: "grid",
          background:
            "linear-gradient(180deg, #FFF6CF 0%, rgba(255, 253, 244, 0.60) 5%, #FFFDF4 100%, #FFFDF4 100%), #FFF",
        }}
      >
        <BabyPeekIntroWrapper>
          <BabyPeekMultipleReqHeader />
          <BabyPeekMobileHeaderImageWrapper
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "40px",
              margin: "40px 0px",
              width: windowWidth,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: windowWidth,
              }}
            >
              <div>
                <BabyPeekIcon />
              </div>
              <BabyPeekRatingsWrapper
                onClick={() => {
                  const anchorEl = document.getElementById("babypeekRatings");
                  if (anchorEl) {
                    anchorEl.scrollIntoView();
                  }
                }}
              >
                <BabyPeekRatings />
              </BabyPeekRatingsWrapper>
            </div>
          </BabyPeekMobileHeaderImageWrapper>
          <div
            style={{
              display: "grid",
              gridTemplateRows: "auto auto auto",
              gap: "16px",
            }}
          >
            <BabyPeekIntroBottomMobileGrid
              style={{
                padding: windowWidth < 400 ? "0px 12px" : "0px 32px",
              }}
            >
              <BabyPeekIntroTitle
                deviceType={deviceType}
                style={{
                  textAlign: "center",
                }}
              >
                {t("babyPeek.intro.title")}
              </BabyPeekIntroTitle>
              <BabyPeekIntroDescription
                deviceType={deviceType}
                style={{
                  textAlign: "center",
                }}
              >
                {babyPeekReport.experiment_details.landing_page === "a" ? (
                  <Trans
                    i18nKey="babyPeek.intro.descriptionA"
                    components={{ sup: <sup /> }}
                  />
                ) : (
                  <Trans
                    i18nKey="babyPeek.intro.descriptionB"
                    components={{ sup: <sup /> }}
                  />
                )}
              </BabyPeekIntroDescription>
            </BabyPeekIntroBottomMobileGrid>
            <BabyPeekIntroMobileDescriptionWrapper
              style={{ display: "grid", gridGap: "12px" }}
            >
              <>
                {babyPeekReport?.reveal_status === "pending" && (
                  <>
                    <>
                      <BabyPeekButton
                        variant="filled"
                        id="vwo-unlock-babypeek"
                        style={{
                          width: "300px",
                          justifySelf: "center",
                          marginTop: "0px",
                        }}
                        content={<>{t("babyPeek.buttons.unlockBabyPeek")}</>}
                        onClick={() => {
                          if (setLastButtonClick) {
                            setLastButtonClick("IntroMainUnlock");
                            history.push(
                              `${BABYPEEK_URL}/${babypeekPK}/checkout`,
                            );
                          }
                        }}
                      />
                    </>
                  </>
                )}
              </>
            </BabyPeekIntroMobileDescriptionWrapper>
          </div>
        </BabyPeekIntroWrapper>
        <BabyPeekIntroMarqueeWrapper>
          <TraitMarquee mobile />
        </BabyPeekIntroMarqueeWrapper>
        <BabyPeekIntroBodyWrapper>
          {babyPeekReport.unlock_type === "discount_payment" && (
            <BabyPeekPaymentPromotionGradient deviceType={deviceType}>
              <BabyPeekPaymentPromotionGradientContent>
                <BabyPeekPaymentGradientContentSpecialGrid>
                  <BabyPeekPaymentGradientTitle>
                    <BabyPeekIntroInfoBarBigMobile>
                      {t("babyPeek.intro.reports")}
                    </BabyPeekIntroInfoBarBigMobile>
                    <BabyPeekPaymentPromotionalPriceGrid>
                      <DetailedResultsBabyPeekText>
                        {getCentsToDollars(
                          babyPeekReport.bill_details.balance,
                          false,
                        )}
                      </DetailedResultsBabyPeekText>
                      <BabyPeekPaymentGradientTitleStrikeThrough>
                        {getCentsToDollars(24900, true)}
                      </BabyPeekPaymentGradientTitleStrikeThrough>
                    </BabyPeekPaymentPromotionalPriceGrid>
                  </BabyPeekPaymentGradientTitle>

                  <BabyPeekPaymentGradientTitleMobile>
                    <BabyPeekPaymentSummaryItemGridRow>
                      <BabyPeekPaymentSummaryTitleTrait
                        deviceType={deviceType}
                        style={{ display: "flex" }}
                      >
                        <div>
                          <WaveCTA />
                        </div>{" "}
                        {t("babyPeek.traits.groups.hair")}
                      </BabyPeekPaymentSummaryTitleTrait>
                      <BabyPeekPaymentSummaryDescription
                        deviceType={deviceType}
                      >
                        &bull; {t("babyPeek.traits.labels.lightOrDarkHair")}{" "}
                        <br />
                        &bull; {t("babyPeek.traits.labels.redHair")} <br />
                        &bull; {t("babyPeek.traits.labels.hairThickness")}{" "}
                        <br />
                        &bull; {t("babyPeek.traits.labels.hairTexture")} <br />
                      </BabyPeekPaymentSummaryDescription>
                    </BabyPeekPaymentSummaryItemGridRow>

                    <BabyPeekPaymentSummaryItemGridRow>
                      <BabyPeekPaymentSummaryTitleTrait
                        deviceType={deviceType}
                        style={{ display: "flex" }}
                      >
                        <div>
                          <EyeCTA />
                        </div>
                        {t("babyPeek.traits.labels.eyeColor")}
                      </BabyPeekPaymentSummaryTitleTrait>
                      <BabyPeekPaymentSummaryDescription
                        deviceType={deviceType}
                      >
                        {t("babyPeek.traits.labels.eyeColor")}
                      </BabyPeekPaymentSummaryDescription>
                    </BabyPeekPaymentSummaryItemGridRow>
                  </BabyPeekPaymentGradientTitleMobile>
                  <BabyPeekPaymentGradientTitleMobile>
                    <BabyPeekPaymentSummaryItemGridRow>
                      <BabyPeekPaymentSummaryTitleTrait
                        style={{ display: "flex" }}
                        deviceType={deviceType}
                      >
                        <div>
                          <TeethCTA />
                        </div>{" "}
                        {t("babyPeek.traits.groups.otherTraits")}
                      </BabyPeekPaymentSummaryTitleTrait>
                      <BabyPeekPaymentSummaryDescription
                        deviceType={deviceType}
                      >
                        &bull; {t("babyPeek.traits.labels.teeth")} <br />
                        &bull; {t("babyPeek.traits.labels.freckles")} <br />
                        &bull;{" "}
                        {t(
                          "babyPeek.traits.labels.asparagusOdorDetection",
                        )}{" "}
                        <br />
                      </BabyPeekPaymentSummaryDescription>
                    </BabyPeekPaymentSummaryItemGridRow>

                    <BabyPeekPaymentSummaryItemGridRow>
                      <BabyPeekPaymentSummaryTitleTrait
                        style={{ display: "flex" }}
                        deviceType={deviceType}
                      >
                        <div>
                          <TasteCTA />
                        </div>
                        {t("babyPeek.traits.groups.taste")}
                      </BabyPeekPaymentSummaryTitleTrait>
                      <BabyPeekPaymentSummaryDescription
                        deviceType={deviceType}
                      >
                        &bull; {t("babyPeek.traits.labels.cilantro")} <br />
                        &bull; {t("babyPeek.traits.labels.bitterTaste")} <br />
                        &bull; {t("babyPeek.traits.labels.sweet")} <br />
                        &bull; {t("babyPeek.traits.labels.sweetVsSalty")} <br />
                      </BabyPeekPaymentSummaryDescription>
                    </BabyPeekPaymentSummaryItemGridRow>
                  </BabyPeekPaymentGradientTitleMobile>
                  <BabyPeekIntroPaymentMobileButtonWrapper>
                    <>
                      <BabyPeekButton
                        id="vwo-unlock-babypeek"
                        variant="outline"
                        content={<>{getUnlockButtonText()}</>}
                        onClick={() => {
                          if (setLastButtonClick) {
                            setLastButtonClick("PromoUnlock");
                          }

                          history.push(
                            `${BABYPEEK_URL}/${babypeekPK}/checkout`,
                          );
                        }}
                      />
                    </>
                  </BabyPeekIntroPaymentMobileButtonWrapper>
                </BabyPeekPaymentGradientContentSpecialGrid>
              </BabyPeekPaymentPromotionGradientContent>
            </BabyPeekPaymentPromotionGradient>
          )}
          <BabyPeekIntroInfoBarWrapper
            deviceType={deviceType}
            windowWidth={windowWidth}
          >
            <div>
              <BabyPeekIntroInfoBarBigMobile>
                {t("babyPeek.traits.labels.eyeColor")}
              </BabyPeekIntroInfoBarBigMobile>
              <BabyPeekIntroInfoBarBigMobile>
                {t("babyPeek.traits.labels.hairColor")}
              </BabyPeekIntroInfoBarBigMobile>
              <BabyPeekIntroInfoBarBigMobile style={{ marginBottom: "24px" }}>
                {t("babyPeek.traits.labels.hairTexture")}
              </BabyPeekIntroInfoBarBigMobile>
              <BabyPeekIntroInfoBarDescriptionMobile>
                {t("babyPeek.intro.probabilityDescription")}
              </BabyPeekIntroInfoBarDescriptionMobile>
            </div>
            <div style={{ display: "grid", marginBottom: "-32px" }}>
              <TraitSummaryList />
            </div>
          </BabyPeekIntroInfoBarWrapper>
          <BabyPeekIntroInfoBarWrapper
            deviceType={deviceType}
            windowWidth={windowWidth}
          >
            <div>
              <BabyPeekIntroInfoBarBigMobile style={{ marginBottom: "24px" }}>
                {t("babyPeek.intro.futureFoodie.title")}
              </BabyPeekIntroInfoBarBigMobile>

              <BabyPeekIntroInfoBarDescriptionMobile>
                {t("babyPeek.intro.futureFoodie.description")}
              </BabyPeekIntroInfoBarDescriptionMobile>
              <div style={{ display: "grid", marginTop: "10px" }}>
                <FutureFoodie />
              </div>
            </div>
          </BabyPeekIntroInfoBarWrapper>
          <BabyPeekIntroInfoBarWrapper
            deviceType={deviceType}
            windowWidth={windowWidth}
          >
            <div>
              <div style={{ marginTop: "-32px", marginBottom: "-195px" }}>
                <BabyPeekGamesExplosions />
              </div>
              <BabyPeekGamesExclusive />
              <BabyPeekIntroInfoBarBigMobile style={{ marginBottom: "24px" }}>
                {t("babyPeek.games.title")}
              </BabyPeekIntroInfoBarBigMobile>
              <BabyPeekIntroInfoBarDescriptionMobile>
                {t("babyPeek.games.unlockDescription")}
              </BabyPeekIntroInfoBarDescriptionMobile>
              <div style={{ display: "grid", marginTop: "10px" }}>
                <BabyPeekAccordions
                  data={babyPeekGameAccordion(babypeekPK, auth?.access_token)}
                />
              </div>
            </div>
          </BabyPeekIntroInfoBarWrapper>
          <BabyPeekIntroInfoBarWrapper
            style={{ position: "relative", justifyContent: "center" }}
            deviceType={deviceType}
            id="babypeekRatings"
          >
            <BabyPeekRatingsStar />

            <div style={{ display: "grid", justifyItems: "center" }}>
              <BabyPeekVideoEmbed babypeekPK={babypeekPK} />
              <BabyPeekPreTestMessage>
                {t("babyPeek.intro.videoCaption")}
              </BabyPeekPreTestMessage>
            </div>
            <BabyPeekVerticalQuotes />
          </BabyPeekIntroInfoBarWrapper>

          <BabyPeekIntroCTAWrapper deviceType={deviceType}>
            <BabyPeekCTATitle deviceType={deviceType}>
              {t("babyPeek.intro.technologyTitle")}
            </BabyPeekCTATitle>
            <TechnologyGene />
            <BabyPeekIntroInfoBarDescriptionMobile>
              {t("babyPeek.intro.technologyDescription")}
            </BabyPeekIntroInfoBarDescriptionMobile>
          </BabyPeekIntroCTAWrapper>
          <BabyPeekIntroFAQAccordionWrapper deviceType={deviceType}>
            <BabyPeekFAQTitle deviceType={deviceType}>
              {t("babyPeek.faq.title")}
            </BabyPeekFAQTitle>
            <BabyPeekMobileFAQ>
              <BabyPeekAccordions data={getBabyPeekFAQAccordion()} />
            </BabyPeekMobileFAQ>
          </BabyPeekIntroFAQAccordionWrapper>
          <BabyPeekDisclaimer
            style={{
              display: "grid",
              backgroundColor: "#fff",
              backgroundSize: "100% 100%",
            }}
          >
            <BabyPeekDisclaimerTitle>
              {t("babyPeek.disclaimer.title")}
            </BabyPeekDisclaimerTitle>
            <BabyPeekDisclaimerGrid deviceType={deviceType}>
              <ul>
                <li>
                  <BabyPeekDisclaimerText>
                    {t("babyPeek.disclaimer.funOnly")}
                  </BabyPeekDisclaimerText>
                </li>
                <li>
                  <BabyPeekDisclaimerText>
                    {t("babyPeek.disclaimer.resultsMayVary")}
                  </BabyPeekDisclaimerText>
                </li>
              </ul>

              <ul>
                <li>
                  <BabyPeekDisclaimerText>
                    {t("babyPeek.disclaimer.doctorNotOrdered")}
                  </BabyPeekDisclaimerText>
                </li>
                <li>
                  <BabyPeekDisclaimerText>
                    {t("babyPeek.disclaimer.contactBillionToOne")}
                  </BabyPeekDisclaimerText>
                </li>
              </ul>
            </BabyPeekDisclaimerGrid>
          </BabyPeekDisclaimer>
        </BabyPeekIntroBodyWrapper>

        {scrollPosition > 400 && (
          <BabyPeekMobileButtonSticky>
            <>
              <BabyPeekButton
                id="vwo-unlock-babypeek"
                variant="filled"
                content={<>{getUnlockButtonText()}</>}
                onClick={() => {
                  if (setLastButtonClick) {
                    setLastButtonClick("IntroMainUnlock");
                  }

                  history.push(`${BABYPEEK_URL}/${babypeekPK}/checkout`);
                }}
                className="unlock-button"
              />
            </>
          </BabyPeekMobileButtonSticky>
        )}
      </div>
    </>
  );
};
